import { useMutation, useQueryClient } from '@tanstack/react-query';

import { normalizeAccess } from '../../../domain/access';
import type { ExtranetInviteOutput, InviteMemberBody } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `POST /v1/invitation/invite` — depuis la v1.9.0 la route répond 200 avec un
 * `outcome` : l'utilisateur reçoit un email s'il est nouveau, sinon l'accès lui
 * est accordé directement sans email. L'appelant doit distinguer les deux.
 * Un accès accordé fait apparaître un membre, pas une invitation : les deux
 * listes sont invalidées.
 */
export const useInviteMember = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: InviteMemberBody) =>
      getExtranetApi().post<InviteMemberBody, ExtranetInviteOutput>('/v1/invitation/invite', {
        ...body,
        access: normalizeAccess(body.access),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: extranetQueryKeys.invitations.root() });
      queryClient.invalidateQueries({ queryKey: extranetQueryKeys.members.root() });
    },
  });
};
